/**
 * Typed client calls for the session/membership + screen endpoints (04 §1).
 */
import type {
  GuestDTO,
  SessionDTO,
  SessionState,
  Settings,
  SettingsPatch,
} from '@singparty/shared';
import { apiGet, apiPost, api } from './apiClient';

export const sessionApi = {
  create: (name?: string, hostName?: string) =>
    apiPost<{ session: SessionDTO }>('/api/sessions', {
      ...(name ? { name } : {}),
      ...(hostName ? { hostName } : {}),
    }),

  /** Host renames themselves on the console. */
  setHostName: (sid: string, name: string) =>
    api<{ guest: GuestDTO }>(`/api/session/host-name?sid=${sid}`, { method: 'PATCH', body: { name } }),

  listMine: () => apiGet<{ active: SessionDTO[]; ended: SessionDTO[] }>('/api/sessions'),

  join: (code: string, name: string) =>
    apiPost<{ sessionId: string; guest: GuestDTO }>('/api/session/join', { code, name }),

  state: (sid: string) => apiGet<SessionState>('/api/session/state', { sid }),

  screenUrl: (sid: string) => apiPost<{ url: string }>(`/api/session/screen-url?sid=${sid}`),

  updateSettings: (sid: string, patch: SettingsPatch) =>
    api<{ settings: Settings; version: number }>(`/api/session/settings?sid=${sid}`, {
      method: 'PATCH',
      body: patch,
    }),

  end: (sid: string) => apiPost<{ status: 'ended'; version: number }>(`/api/session/end?sid=${sid}`),

  linkTv: (sid: string, pairCode: string) =>
    apiPost<{ linked: true }>(`/api/session/link-tv?sid=${sid}`, { pairCode }),

  // ── TV pairing (04 §1.10) ──
  pairStart: () =>
    apiPost<{ pairCode: string; pairSecret: string; expiresInS: number }>('/api/screen/pair/start'),

  pairStatus: (code: string, secret: string) =>
    apiGet<{ linked: false } | { linked: true; sessionId: string }>('/api/screen/pair/status', {
      code,
      secret,
    }),

  claim: (st?: string) => apiPost<SessionState>('/api/screen/claim', st ? { st } : {}),
};
